import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCybergrantLogoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Livello_2",
	"data-name": "Livello 2",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 50.2 55",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .cls-1 {\n        fill: #2e5090;\n      }\n    " }) }), /* @__PURE__ */ _jsx("g", {
		id: "verticali",
		children: /* @__PURE__ */ _jsx("g", {
			id: "blu_spessore_2_5_rast",
			"data-name": "blu spessore 2,5 rast",
			children: /* @__PURE__ */ _jsx("g", {
				id: "cybergrant",
				children: /* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M32.55,15.04h-4.57c-.13,0-.25-.01-.37-.01h-4.49c-2.65.02-4.83.66-6.32,2.09-1.56,1.49-2.24,3.72-2.24,6.46v7.81c0,1.32.16,2.51.49,3.57-5.9-1.42-10.35-7.59-10.35-14.97,0-8.42,5.81-15.28,12.95-15.28h7.24c1.3,0,2.35-1.05,2.35-2.35s-1.05-2.35-2.35-2.35h-7.24C7.92,0,0,8.96,0,19.98s7.92,19.98,17.65,19.98h7.24s.01,0,.02,0h2.69c2.81,0,5.09-.64,6.63-2.12,1.54-1.49,2.21-3.72,2.21-6.45v-7.77c0-1.2-.14-2.3-.41-3.28,5.45,1.8,9.46,7.7,9.46,14.7,0,8.42-5.81,15.28-12.95,15.28h-4.89v-3.89c0-1.3-1.05-2.35-2.35-2.35s-2.35,1.05-2.35,2.35v5.12c0,1.91,1.56,3.47,3.47,3.47h6.12c9.73,0,17.65-8.96,17.65-19.98s-7.92-19.98-17.65-19.98ZM32.1,23.55v7.9c0,1.2-.16,1.99-.39,2.46-.21.43-.55.75-1.08.97-.57.23-1.49.37-2.84.37h-4.56c-1.35,0-2.27-.15-2.84-.37-.53-.21-.87-.53-1.08-.97-.23-.47-.39-1.26-.39-2.46v-7.93c0-1.17.16-1.96.39-2.45.21-.44.55-.76,1.09-.97.58-.23,1.49-.36,2.81-.34h0s0,0,0,0h2.07s0,0,0,0h2.51c1.3,0,2.21.15,2.79.38.54.21.88.53,1.09.97.24.49.39,1.28.39,2.45Z"
				})
			})
		})
	})]
});
export default SvgCybergrantLogoIcon;
